import { XMLParser } from 'fast-xml-parser'
import type { ISamlMetadata } from '../components/idp/cards/ProviderCard'

const SAML_BINDINGS = {
  REDIRECT: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-Redirect',
  POST: 'urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST'
}

const parseXML: (content: string) => ISamlMetadata = (content) => {

  const parsedJSONContent = new XMLParser({ ignoreAttributes: false, removeNSPrefix: true, attributeNamePrefix: '' }).parse(content)

  const certificate = parsedJSONContent['EntityDescriptor']['IDPSSODescriptor']['KeyDescriptor']['KeyInfo']['X509Data']['X509Certificate']

  // const ssoUrl = parsedJSONContent['EntityDescriptor']['IDPSSODescriptor']['SingleSignOnService']
  //   .find((item: any) => SAML_BINDINGS.REDIRECT.localeCompare(item.Binding, undefined, { sensitivity: 'accent' }))?.Location

  const loginUrl = parsedJSONContent['EntityDescriptor']['IDPSSODescriptor']['SingleSignOnService']
    .find((item: any) => SAML_BINDINGS.POST.localeCompare(item.Binding, undefined, { sensitivity: 'accent' }))?.Location

  const ssoUrl = loginUrl

  const identityProviderId = parsedJSONContent['EntityDescriptor']['entityID']

  return {
    loginUrl,
    ssoUrl,
    certificate,
    identityProviderId,
  }
}

export default parseXML
